export default __webpack_public_path__ + "static/media/property_1016.73c04444.png";